<mat-list role="list">
    <mat-list-item role="listitem" *ngFor="let point of data">
        {{point}}
    </mat-list-item>
</mat-list>